/**
 * Cards Module
 * 
 * @description
 * <p>Sets up various types of cards with swipe actions, pips and resize handlers</p>
 * <p>Adds swipe and click events to card elements and injects nav element (applies to .card-tabbed, .card-full, .card-slider, .card-slider-group)</p>
 * <p>Self-initializes when you include this module</p>
 * 
 * @module cards
 */
( /* @lends module:cards */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
		dom = {},
		navBtns = '<div class="arrow-nav"><button type="button" class="left"><span class="sr-only">scroll Left</span></button><button type="button" class="right"><span class="sr-only">scroll Right</span></button></div>',
		data = [];

	/**
	 * Card Slider Initializer
	 */
	function init(){

		// register modules/libraries for local use
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		dom.cards = $('.card-tabbed, .card-full, .card-slider, .card-slider-group');

		dom.cards.each(function(parentId){
			
			var obj = $(this);
			var card = obj.find('.card');

			if(card.length > 1) {
				obj.on('swipeleft', function(){
					next('right',parentId);
				}).on('swiperight', function(){
					next('left',parentId);
				});
			}

			var descNav = obj.find('.desc-nav');
			descNav.append('<div class="nav"></div>');

			var nav = descNav.find('.nav');

			
			var cards = [];
			trace.push('card.length = '+card.length);

			var cardsH = 0;

			card.each(function(cardId){

				var cardObj = $(this);
				var btn = cardObj.find('.btn');


				if(card.length >1) {
					btn.attr('data-id',cardId);
					btn.attr('data-parent',parentId);
					btn.appendTo(nav);

					btn.on('click', function(){
						set(cardId, parentId);
					});

					var info = cardObj.find('.info').find('.holder');
					info.append(navBtns);

					var left = cardObj.find('.left');
					left.on('click', function(){
						next('left',parentId);
					});

					var right = cardObj.find('.right');
					right.on('click', function(){
						next('right',parentId);
					});	
				}

				var cardH = cardObj.height();

				if(cardH > cardsH) cardsH = cardH;

				trace.push('cardH = '+cardH);
				
				cards.push({'obj':cardObj, 'btn':btn});	
			});

			data.push({'obj':obj, 'cards':cards, 'current':-1});

			next('right',parentId);
			
			
		});

		window.addEventListener("resize", function() {
			setTimeout(function(){ resize(); }, 500);	
		});

		resize();

	}

	function resize() {
		trace.push('resize ');

		dom.cards.each(function(){
			
			var obj = $(this);
			var cardsH = 0;
			var card = obj.find('.card');

			card.each(function(){
				var cardObj = $(this);
				var cardH = cardObj.height();
				if(cardH > cardsH) cardsH = cardH;
			});

			var isCustomCard = obj[0].classList.contains('card-slider-group');
			
			if(isCustomCard && window.innerWidth < 750) {
				obj.find('.cards').height('auto');
			} else {
				obj.find('.cards').height(cardsH);
			}
		});
	}

	function set(cardId, parentId) {
		trace.push('set cardId = '+cardId+" parentId = "+parentId);

		if(data[parentId].current != -1) {
			data[parentId].cards[data[parentId].current].btn.removeClass('active');
			data[parentId].cards[data[parentId].current].obj.removeClass('active');
		}
		data[parentId].current = cardId;
		setTimeout(function(){ show(parentId); }, 500);	
	}

	function next(direction,parentId) {
		trace.push('next direction = '+direction+" parentId = "+parentId);

		if(data[parentId].current != -1) {
			data[parentId].cards[data[parentId].current].btn.removeClass('active');
			data[parentId].cards[data[parentId].current].obj.removeClass('active');
		}
		if(direction == "right") {
			data[parentId].current++;
		} else {
			data[parentId].current--;
		}

		trace.push('data[parentId].current = '+data[parentId].current);

		if(data[parentId].current > data[parentId].cards.length-1) {
			data[parentId].current = 0;
		}
		if(data[parentId].current < 0) {
			data[parentId].current = data[parentId].cards.length-1;
		}

		trace.push('data[parentId].current = '+data[parentId].current);

		setTimeout(function(){ show(parentId); }, 500);	
	}

	function show(parentId) {
		resize();
		data[parentId].cards[data[parentId].current].btn.addClass('active');	
		data[parentId].cards[data[parentId].current].obj.addClass('active');	
	}

	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {},jQuery);